export default {
  title: {
    id: 'product_page_verified_refurbished_carousel_title',
    defaultMessage: 'Restored professionally',
  },
  subtitle: {
    id: 'product_page_verified_refurbished_carousel_subtitle',
    defaultMessage: '25-point inspection',
  },
  subtitleDynamic: {
    id: 'product_page_verified_refurbished_carousel_subtitle_by_number',
    defaultMessage: '{nb_points}-point inspection',
  },
  titleNew: {
    id: 'product_page_verified_refurbished_carousel_title_new',
    defaultMessage: '25-point inspection',
  },
  dynamicTitleNew: {
    id: 'product_page_verified_refurbished_carousel_title_by_number_new',
    defaultMessage: '{nb_points}-point inspection',
  },
  subtitleNew: {
    id: 'product_page_verified_refurbished_carousel_subtitle_new',
    defaultMessage: 'Guaranteed by the Back Market Promise',
  },
  prevSlideText: {
    id: 'product_page_verified_refurbished_carousel_prev_slide',
    defaultMessage: 'Display previous slide',
  },
  nextSlideText: {
    id: 'product_page_verified_refurbished_carousel_next_slide',
    defaultMessage: 'Display next slide',
  },
} as const
